import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import api from "@/lib/api";

export default function Edits() {
    const [edits, setEdits] = useState([]);
    useEffect(() => {
        api.get("/products/edits").then(({ data }) => setEdits(data.items));
    }, []);

    return (
        <div className="section" data-testid="edits-page">
            <div className="section-head">
                <div>
                    <div className="eyebrow">Curated Collections</div>
                    <h1 className="h-display">The <em>Edits</em></h1>
                </div>
            </div>

            <div className="edits-grid">
                {edits.map((e, i) => (
                    <motion.div
                        key={e.slug}
                        className={`edit-card ${i % 3 === 0 ? "big" : "small"}`}
                        initial={{ opacity: 0, y: 30 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        viewport={{ once: true }}
                        transition={{ duration: 0.8, delay: i * 0.06, ease: [0.19, 1, 0.22, 1] }}
                    >
                        <Link to={`/shop?edit=${e.slug}`}>
                            <img src={e.image} alt={e.title} loading="lazy" />
                            <div className="edit-card-copy">
                                <div className="eyebrow">The Edit</div>
                                <h3 className="title">{e.title}</h3>
                                <p className="blurb">{e.blurb}</p>
                            </div>
                        </Link>
                    </motion.div>
                ))}
            </div>
        </div>
    );
}
